import localstory from "localstory";
const isClient = process.env.BUILD_TARGET === "client";
const flightsLocalStore = isClient && typeof window !== "undefined" ? localstory(window.localStorage, "flights") : undefined;
export { flightsLocalStore };
